module.exports = __webpack_public_path__ + "static/media/icon_7.cb4fad7c.svg";